import { render, staticRenderFns } from "./blockPage.vue?vue&type=template&id=a91ed360"
import script from "./blockPage.vue?vue&type=script&lang=js"
export * from "./blockPage.vue?vue&type=script&lang=js"
import style0 from "./blockPage.vue?vue&type=style&index=0&id=a91ed360&prod&lang=scss"
import style1 from "./blockPage.vue?vue&type=style&index=1&id=a91ed360&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports